if (process.env.BUILD_GC === 'cms' || process.env.BUILD_GC === 'cicp') {
  module.exports = require('./cms')
} else {
  module.exports = null
}
